<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.consultations', 2) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="row">
                    <div class="col-lg-6 col-xl-6">
                        <router-link :to="{ name: 'consultations-obstetrics' }">
                            <stats-card
                                    :title="$tc('message.obstetricConsultations', 2)"
                                    type="gradient-red"
                                    icon="fas fa-stethoscope"
                                    class="mb-4"
                            ></stats-card>
                        </router-link>
                    </div>

                    <div class="col-lg-6 col-xl-6">
                        <router-link :to="{ name: 'consultations-generals' }">
                            <stats-card
                                    :title="$tc('message.generalConsultations', 2)"
                                    type="gradient-green"
                                    icon="fas fa-file-medical"
                                    class="mb-4"
                            ></stats-card>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MedicalManagement"
    }
</script>

<style scoped>

</style>